/* eslint-disable no-console */

import { register } from 'register-service-worker'

//imoport gesto de estado vuex
import store from '@/store/index'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.warn(
        'event ready, La aplicación se está sirviendo desde la caché de un service worker.' 
      )
      const XactualizarApp = store.getters.XactualizarApp;
      if (XactualizarApp.tipo == 0) {
             store.dispatch('triggerActualizarApp', { estado: false, mensaje: '', actualizar:false  });
      }


    },
    registered () {
      console.warn('event registere, Service worker registrado.');
    },
    cached () {
      console.warn('event cached, El contenido se ha almacenado en caché para su uso sin conexión.');
    },
    updatefound () {
      console.warn('event updatefound Se está descargando nuevo contenido.');
      store.dispatch('triggerActualizarApp', { estado: true, mensaje: 'Se está descargando nuevo contenido',actualizar:false  });
    },
    updated () {
      console.warn('event updated Nuevo contenido disponible; por favor actualice.');
      store.dispatch('triggerActualizarApp', { estado: true, mensaje: 'Nuevo contenido disponible; por favor actualice.', actualizar:true });
   
    },
    offline () {
      console.warn('event offline No se ha encontrado conexión a internet. La aplicación se está ejecutando en modo sin conexión.');
    },
    error (error) {
      console.error('Error al registrar el service worker:', error)
    }
  })
}
